const CURRENCY = {
    DOLLAR: 'DOLLAR',
    EURO: 'EURO'
};

export default CURRENCY;
